module.exports = __webpack_public_path__ + "img/growth-icon-01.4bd2922a.gif";